module.exports = Studio.libraries['filesaver.js-npm'];


/*****************
 ** WEBPACK FOOTER
 ** external "Studio.libraries['filesaver.js-npm']"
 ** module id = 5
 ** module chunks = 0
 **/